import { memo } from 'react';
import PropTypes from 'prop-types';
import Checkbox from '@JohnLewisPartnership/jl-design-system/components/checkbox/Checkbox';
import facetType from '../../../../utils/types/facet';

const CheckboxFacet = ({
  ariaLabel = undefined,
  disabled = false,
  id = '',
  name = '',
  value = {},
}) => (
  <Checkbox
    ariaLabel={ariaLabel}
    checked={value.selected}
    disabled={disabled}
    id={id}
    isControlled
    isRealFormControl={false}
    label={`${value.label} (${value.quantity})`}
    name={name}
  />
);

CheckboxFacet.propTypes = {
  ariaLabel: PropTypes.string,
  disabled: PropTypes.bool,
  id: PropTypes.string,
  name: PropTypes.string,
  value: facetType,
};

export default memo(CheckboxFacet);
